import { CircularProgress } from '@material-ui/core';
import React, { Component, createRef } from 'react';
import image1 from '../../../Assets/images/Activation/DEVICE_ICON.svg';
import image2 from '../../../Assets/images/Activation/DEVICE_ID.svg';
import Android from '../../../Assets/images/Activation/android.svg';
import Apple from '../../../Assets/images/Activation/iOSlogo.svg';
import Button from '../../../components/Button/Button';
import TextField from '../../../components/Textfield/TextField';
import './Steps.scss';
// import AmericanExpress from '../../../Assets/images/Activation/americanExpress.svg';
import { Checkbox } from '@material-ui/core';
import _ from 'lodash';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { store } from 'react-notifications-component';
import { geocodeByAddress } from 'react-places-autocomplete';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import tick from '../../../Assets/images/Activation/tick.svg';
import BackButton from '../../../Assets/images/commonImages/backButton.svg';
import AutoComplete from '../../../components/AutoComplete/AutoComplete';
import SelectDropDown from '../../../components/SelectDropDown/SelectDropDown';
import { isPaymentEnabled, maxLength } from '../../../config';
import { usaState } from '../../../global/USAStateList';
// import {  pushTrackingEventsToGAAndFBNew } from '../../../global/commonFunctions/GaAndFb';
import { globalVal } from '../../../global/globalvalues';
import { activationPage } from '../../../global/texts/postActivation/activation';
import * as ActivationAction from '../../../store/Activation/actions';
import * as Action from '../../../store/Checkout/actions';
import * as HomeAction from '../../../store/HomePage/actions';
import * as PostActivationAction from '../../../store/PostActivation/actions';
import firebase from '../../../utils/firebase';
// import Skeleton from 'react-loading-skeleton';
import failedIcon from '../../../Assets/images/Activation/failed.svg';
import TagManager from 'react-gtm-module';
import { getUserName } from '../../../global/commonFunctions/getUserName';

type initialProps = {
    history: any;
    changeCurrentPage: any;
    CheckoutActions: any;
    CheckoutState: any;
    ActivationActions: any;
    ActivationState: any;
    homeAction: any;
    homeState: any;
    PostActivationAction: any;
    PostActivationState: any;
};
type initialState = {
    imeiNumber: string;
    checkClick: boolean;
    imeiErr: string;
    isData: boolean;
    isCompatible: boolean;
    model: string;
    modalData: {
        activationFailedPopup: {
            mainButtonText: string;
            message: string;
            showCallButton: boolean;
            showChatButton: boolean;
            showMainButton: boolean;
        };
        amount: string;
        emailNote: string;
        shopNewPhones: string;
        shopRefurbished: string;
        supportNote: string;
        supportNote_2: string;
    };
    is5Gmodal: boolean;
    showBuySimModal: boolean;
    isShippingConfirm: boolean;
    showSimPreferenceModal: boolean;
    eSimClicked: boolean;
    simClicked: boolean;
    simPreference: string;
    isEsim: boolean;
    sendSimOptions: any;
    isCurrentESim: boolean;
    usedIMEIs: any;
    isIMEIused: boolean;
    changeCard: boolean;
    changeAddressModal: boolean;
    formData: {
        name: string;
        address1: string;
        apt: string;
        city: string;
        state: string;
        zip: string;
        stateCode: string;
        stateCodeShipping: string;
        shipPlan: string;
    };
    formDataValidation: boolean;
    shippingAddress: {
        name: string;
        address1: string;
        apt: string;
        city: string;
        state: string;
        zip: string;
        stateCode: string;
        stateCodeShipping: string;
    };
    billingAddress: {
        name: string;
        address1: string;
        apt: string;
        city: string;
        state: string;
        zip: string;
        stateCode: string;
        stateCodeShipping: string;
    };
    selectedCard: any;
    email: any;
    ccNumberMask: string;
    shippingTax: number;
    loader: boolean;
    shipmentOrderError: string;
    invalidImei: boolean;
    notSupported: boolean;
    showShippingAdd: boolean;
    changeShipAddress: boolean;
    orderPlaced: boolean;
    simCost: number;
    shippingAmount: number;
    deliveryDays: number;
    isInvalidImei: boolean;
    shippingData: any;
    customerDetails: any;
};
export class Step1 extends Component<initialProps, initialState> {
    private formRef: React.RefObject<HTMLFormElement>;
    constructor(props: initialProps) {
        super(props);
        this.formRef = createRef<HTMLFormElement>();
    }
    state = {
        imeiNumber: '',
        checkClick: false,
        imeiErr: '',
        isData: false,
        isCompatible: false,
        model: '',
        modalData: {
            activationFailedPopup: {
                mainButtonText: '',
                message: '',
                showCallButton: false,
                showChatButton: false,
                showMainButton: false,
                title: '',
            },
            amount: '',
            emailNote: '',
            shopNewPhones: '',
            shopRefurbished: '',
            supportNote: '',
            supportNote_2: '',
        },
        is5Gmodal: false,
        showBuySimModal: false,
        isShippingConfirm: true,
        showSimPreferenceModal: false,
        simClicked: false,
        eSimClicked: false,
        simPreference: '',
        isEsim: false,
        sendSimOptions: [
            { label: 'USPS First Class Mail (3-6 days) - $3.00', value: 'USPS First Class Mail', cost: 3 },
            { label: 'USPS Priority Mail  (2-4 days) - $10.00', value: 'USPS Priority Mail', cost: 10 },
            { label: 'USPS Priority Express (1-2 days) - $25.00', value: 'USPS Priority Express', cost: 25 },
        ],
        isCurrentESim: false,
        usedIMEIs: [],
        isIMEIused: false,
        changeCard: false,
        changeAddressModal: false,
        formData: {
            name: '',
            address1: '',
            apt: '',
            city: '',
            state: '',
            zip: '',
            stateCode: '',
            stateCodeShipping: '',
            shipPlan: '',
        },
        formDataValidation: false,
        shippingAddress: {
            name: '',
            address1: '',
            apt: '',
            city: '',
            state: '',
            zip: '',
            stateCode: '',
            stateCodeShipping: '',
        },
        billingAddress: {
            name: '',
            address1: '',
            apt: '',
            city: '',
            state: '',
            zip: '',
            stateCode: '',
            stateCodeShipping: '',
        },
        selectedCard: null,
        ccNumberMask: '',
        email: '',
        shippingTax: 0,
        loader: false,
        shipmentOrderError: '',
        invalidImei: false,
        notSupported: false,
        showShippingAdd: false,
        changeShipAddress: false,
        orderPlaced: false,
        simCost: 0,
        shippingAmount: 0,
        deliveryDays: 0,
        isInvalidImei: false,
        shippingData: {
            carrierCode: '',
            deliveryDays: 0,
            name: '',
            reachCarrierId: '',
            serviceCode: '',
            serviceType: '',
            shippingAmount: 0,
            taxAmount: 0,
        },
        customerDetails: {
            id: '',
            imei: '',
            addresses: '',
        },
    };

    componentDidMount() {
        let secondaryCustomer: any = localStorage.getItem('secondaryCustomerDetail');
        secondaryCustomer = JSON.parse(secondaryCustomer);
        let currentdetails: any = localStorage.getItem('customerDetail');
        currentdetails = JSON.parse(currentdetails);

        isPaymentEnabled && this.fetchData();
        let user1: any = localStorage.getItem('currentuser');
        user1 = JSON.parse(user1);

        let shippingAdd: any =
            currentdetails &&
            currentdetails.addresses &&
            currentdetails.addresses.find((el: any) => el.type === 'shipping');
        let billingAdd: any =
            currentdetails &&
            currentdetails.addresses &&
            currentdetails.addresses.find((el: any) => el.type === 'billing');

        let form: any = this.state.formData;
        form['shipPlan'] = this.state.sendSimOptions[0]?.label;
        this.setState({
            shippingAddress: _.set({ ...shippingAdd }),
            billingAddress: _.set({ ...billingAdd }),
            email: currentdetails?.emailId,
            formData: form,
        });
        if (!secondaryCustomer && currentdetails) {
            this.setState({
                // imeiNumber: currentdetails?.linePreferences?.line1?.imei,
                // model: currentdetails?.linePreferences?.line1?.model,
                // isData: currentdetails?.linePreferences?.line1?.imei ? true : false,
                isCurrentESim: currentdetails?.esim,
                customerDetails: currentdetails,
            });
        } else if (secondaryCustomer) {
            this.setState({
                isCurrentESim: secondaryCustomer?.esim,
                customerDetails: secondaryCustomer,
            });
        }
        // let newArr: any = [];
        // Object.values(currentdetails?.linePreferences).map((el: any) => {
        //     if (el.imei) {
        //         newArr.push(el.imei);
        //     }
        // });
        // this.setState({
        //     usedIMEIs: newArr,
        // });
        this.removeAllTickers();

        let email: string = currentdetails?.emailId;
        if (currentdetails) {
            this.setState({
                isEsim: currentdetails.esim,
            });
        }
        if (secondaryCustomer) {
            if (
                this.props.PostActivationState &&
                this.props.PostActivationState.group &&
                this.props.PostActivationState.group.data &&
                this.props.PostActivationState.group.data.length > 0
            ) {
                const data = this.props.PostActivationState.group.data.find(
                    (item: { id: any }) => item.id === secondaryCustomer.id,
                );
                if (data?.imei && data?.model) {
                    this.setState({
                        isData: true,
                        imeiNumber: data.imei,
                        model: data.model,
                    });
                }
            } else {
                this.props.PostActivationAction.customerGroup({ groupId: currentdetails && currentdetails.groupId });
            }
        } else if (
            this.props.CheckoutState.getCustomer &&
            this.props.CheckoutState.getCustomer.status === 'SUCCESS' &&
            this.props.CheckoutState.getCustomer.data
        ) {
            const data: any = this.props.CheckoutState.getCustomer.data;
            if (data.imei && data.model) {
                this.setState({
                    isData: true,
                    imeiNumber: data.imei,
                    model: data.model,
                });
            }
        } else {
            email &&
                this.props.CheckoutActions.GetCustomer({
                    username: encodeURIComponent(email),
                });
        }
        this.props.ActivationActions.getAppData();
    }

    componentWillUnmount() {
        this.removeAllTickers();
    }

    removeAllTickers() {
        store.removeNotification('activationIMEISuccess');
        store.removeNotification('activationIMEIFailedOne');
        store.removeNotification('activationIMEIFailedTwo');
        store.removeNotification('activationNotifyMe');
    }

    componentDidUpdate(prevProps: initialProps) {
        let secondaryCustomer: any = localStorage.getItem('secondaryCustomerDetail');
        secondaryCustomer = JSON.parse(secondaryCustomer);
        let currentdetails: any = localStorage.getItem('customerDetail');
        currentdetails = JSON.parse(currentdetails);

        let cur = this.props && this.props.CheckoutState;
        let prev = prevProps && prevProps.CheckoutState;
        let curA = this.props && this.props.ActivationState;
        let prevA = prevProps && prevProps.ActivationState;
        let curPA = this.props && this.props.PostActivationState;
        let prevPA = prevProps && prevProps.PostActivationState;

        if (
            prevA.getAppData !== curA.getAppData &&
            curA.getAppData &&
            curA.getAppData.status === 'SUCCESS' &&
            curA.getAppData.data
        ) {
            let { simCost, discountPctg } = curA.getAppData.data?.perSimCost?.USA;
            simCost = curA.getAppData.data.perSimCost.USA.cost;
            simCost = simCost - simCost * (discountPctg / 100);
            this.setState({
                simCost: simCost,
                shippingAmount: curA.getAppData.data?.shippingRates[0]?.shippingAmount,
                deliveryDays: curA.getAppData.data?.shippingRates[0]?.deliveryDays,
                shippingData: curA?.getAppData.data?.shippingRates[0],
            });
        }
        if (secondaryCustomer) {
            if (
                prevPA.group !== curPA.group &&
                curPA.group &&
                curPA.group.status === 'SUCCESS' &&
                curPA.group.data &&
                curPA.group.data.length > 0
            ) {
                const data = this.props.PostActivationState.group.data.find(
                    (item: { id: any }) => item.id === secondaryCustomer.id,
                );
                if (data.imei && data.model) {
                    this.setState({
                        isData: true,
                        imeiNumber: data.imei,
                        model: data.model,
                    });
                }
            }
        } else if (
            prev.getCustomer !== cur.getCustomer &&
            cur.getCustomer &&
            cur.getCustomer.status === 'SUCCESS' &&
            cur.getCustomer.data
        ) {
            const data: any = cur.getCustomer.data;
            if (data.imei && data.model) {
                this.setState({
                    isData: true,
                    imeiNumber: data.imei,
                    model: data.model,
                });
            }
        }

        if (prevA.imei !== curA.imei && curA.imei && curA.imei.status === 'SUCCESS' && curA.imei.data) {
            let user1: any = localStorage.getItem('customerDetail');
            user1 = JSON.parse(user1);
            let email: string = user1 && user1.emailId ? user1.emailId : '';

            const id = cur.getCustomer && cur.getCustomer.data && cur.getCustomer.data.id;

            const secondaryId = secondaryCustomer?.id;
            const secondaryEmail = secondaryCustomer?.emailId;

            // if (this.state.isCurrentESim) {
            //     this.setState({ isData: true })
            // } else {
            //     if (curA.imei.data.isValid) {
            //         // this.props.changeCurrentPage('Step2');
            //     } else {
            //         this.setState({ invalidImei: true, isCompatible: true });
            //     }
            // }

            this.setState({
                checkClick: false,
            });

            let payload: any = {};
            if (curA.imei.data.isValid && curA.imei.data.model && curA.imei.data.make) {
                if (this.state.isCurrentESim && !curA.imei.data.esimAvailable) {
                    this.setState({
                        notSupported: true,
                    });
                } else {
                    this.setState({
                        model: curA.imei.data.model,
                        isData: true,
                    });
                    payload = {
                        email: secondaryCustomer ? secondaryEmail : email,
                        device_imei: this.state.imeiNumber,
                        device_make: curA.imei.data.make,
                        device_model: curA.imei.data.model,
                        app_imei_incompatibility_reason: '',
                        is_test: globalVal.hubspot_is_test,
                        is_qa: globalVal.hubspot_is_qa,
                    };
                    this.props.homeAction.getInTouch({
                        data: {
                            emailId: secondaryCustomer ? secondaryEmail : email,
                            hubspotMap: payload,
                        },
                    });
                    this.props.CheckoutActions.UpdateCustomerSource({
                        customerId: secondaryCustomer ? secondaryId : id,
                        data: { imei: this.state.imeiNumber, make: curA.imei.data.make, model: curA.imei.data.model },
                    });
                }
                let currentdetails: any = localStorage.getItem('customerDetail');
                currentdetails = JSON.parse(currentdetails);

                let occurence: any;
                if(secondaryCustomer) {
                    occurence = secondaryCustomer.peerAccountRef.split('|')[2];
                } else {
                    occurence = currentdetails.peerAccountRef.split('|')[2];
                }
                TagManager.dataLayer({
                    dataLayer: {
                        event: "Check",
                        accountNo: currentdetails?.meta?.customer_statement_number,
                        line_number: occurence,
                        Imei: this.state.imeiNumber,
                        Imei_compatible_status: curA.imei.data.isValid
                    },
                  });
                // this.GAAndFBEventsHandler(
                //     "Check", 
                //     currentdetails?.meta?.customer_statement_number, 
                //     occurence, 
                //     [ curA.imei.data.isValid, this.state.imeiNumber]
                // )
            
            } else {
                if (isPaymentEnabled) {
                    const errorMessage = firebase.database().ref('imeiSupport/');
                    errorMessage.on('value', (snapshot: any) => {
                        const data = snapshot.val();
                        this.setState({
                            modalData: data,
                        });
                        payload = {
                            email: secondaryCustomer ? secondaryEmail : email,
                            website_imei_incompatibility_reason: curA.imei.data.errorText
                                ? curA.imei.data.errorText
                                : 'invalid imei',
                            is_test: globalVal.hubspot_is_test,
                            is_qa: globalVal.hubspot_is_qa,
                        };
                        this.props.homeAction.getInTouch({
                            data: {
                                emailId: secondaryCustomer ? secondaryEmail : email,
                                hubspotMap: payload,
                            },
                        });
                        this.setState({
                            isCompatible: true,
                            checkClick: false,
                        });
                    });
                } else {
                    if ((curA.imei.data.isValid && !curA.imei.data.model) || !curA.imei.data.isValid) {
                        this.setState({ isInvalidImei: true, isData: false });
                    } else {
                        this.setState({ notSupported: true, isData: false });
                    }
                }
            }
        }
        if (
            prevA.errorImei !== curA.errorImei &&
            curA.errorImei &&
            curA.errorImei.status === 'FAILURE' &&
            curA.errorImei
        ) {
            if (curA.errorImei.resCode === 40245) {
                let user1: any = localStorage.getItem('currentuser');
                user1 = JSON.parse(user1);
                let email: string = user1 && user1.email ? user1.email : '';
                const secondaryEmail = secondaryCustomer?.emailId;
                let payload = {
                    imei_checked_in_downtime: true,
                    imei_page_imei_entered: this.state.imeiNumber,
                    downtime_api_call: true,
                    downtime_error_message: curA.errorImei.message ? curA.errorImei.message : 'invalid imei',
                    email: secondaryCustomer ? secondaryEmail : email,
                    is_test: globalVal.hubspot_is_test,
                    is_qa: globalVal.hubspot_is_qa,
                };

                this.props.homeAction.getInTouch({
                    data: {
                        emailId: secondaryCustomer ? secondaryEmail : email,
                        hubspotMap: payload,
                    },
                });
            } else if (curA.errorImei.resCode === 40152 || curA.errorImei.exCode === 'IMEI_ALREADY_IN_USE') {
                //error in alert store notification
                window.scroll(0, 0);
                store.addNotification({
                    // title: 'Error',
                    message: curA.errorImei.message,
                    type: 'danger',
                    insert: 'top',
                    container: 'top-full',
                    animationIn: ['animate__animated', 'animate__fadeIn'],
                    animationOut: ['animate__animated', 'animate__fadeOut'],
                    dismiss: {
                        duration: 2000,
                        showIcon: true,
                    },
                    id: 'activationIMEIFailedOne',
                });
            } else if (curA.errorImei.resCode === 40267) {
                //show 5g modal
                this.setState({ is5Gmodal: true });
            } else {
                // show generic error
                window.scroll(0, 0);
                store.addNotification({
                    // title: 'Error',
                    message: activationPage.errorDefault,
                    type: 'danger',
                    insert: 'top',
                    container: 'top-full',
                    animationIn: ['animate__animated', 'animate__fadeIn'],
                    animationOut: ['animate__animated', 'animate__fadeOut'],
                    dismiss: {
                        duration: 2000,
                        showIcon: true,
                    },
                    id: 'activationIMEIFailedTwo',
                });
            }
            this.setState({
                checkClick: false,
            });
        }
        if (
            prev.taxCalculationByAddressType1 !== cur.taxCalculationByAddressType1 &&
            cur.taxCalculationByAddressType1 &&
            cur.taxCalculationByAddressType1.status === 'SUCCESS' &&
            cur.taxCalculationByAddressType1.data
        ) {
            this.setState({
                showBuySimModal: true,
                showSimPreferenceModal: false,
                checkClick: false,
                loader: false,
                shippingTax: cur.taxCalculationByAddressType1.data?.totalTax,
            });
        }
        if (
            prev.shippmentOrder !== cur.shippmentOrder &&
            cur.shippmentOrder &&
            cur.shippmentOrder.status === 'SUCCESS' &&
            cur.shippmentOrder.data
        ) {
            this.updateCustomer();
            let customerDetail: any = localStorage.getItem('customerDetail');
            customerDetail = JSON.parse(customerDetail);
            setTimeout(() => {
                this.setState({ loader: false });
                this.props.history.push({
                    pathname: customerDetail?.category === 'TEST' ? '/activation' : '/track-order',
                    orderId: cur.shippmentOrder.data?.orderId,
                    state: {
                        redirectOnClick: true,
                    }
                });
            }, 1000);
        }
        if (
            prev.errorShippmentOrder !== cur.errorShippmentOrder &&
            cur.errorShippmentOrder &&
            cur.errorShippmentOrder.status === 'FAILURE'
        ) {
            this.setState({ checkClick: false, loader: false });
            this.setState({
                shipmentOrderError: 'Oops!, Something went wrong. Please try again',
            });
        }
        if(prev.updateCustomerSource !== cur.updateCustomerSource && 
            cur.updateCustomerSource && 
            cur.updateCustomerSource.status === "SUCCESS" && 
            cur.updateCustomerSource.data &&
            this.state.formDataValidation
        ) {
            this.setState({
                changeShipAddress: false,
                loader: false,
                showShippingAdd: true,
            });
        }
        
    }
    updateCustomer = () => {
        let secondaryCustomer: any = localStorage.getItem('secondaryCustomerDetail');
        secondaryCustomer = JSON.parse(secondaryCustomer);
        let currentdetails: any = localStorage.getItem('customerDetail');
        currentdetails = JSON.parse(currentdetails);

        if (secondaryCustomer) {
            this.props.CheckoutActions.UpdateCustomerSource({
                customerId: secondaryCustomer?.id,
                data: {
                    esim: false,
                    simType: 'PHYSICAL',
                    activationJourneyStatus: 'IN_PROGRESS',
                },
            });
        } else {
            this.props.CheckoutActions.UpdateCustomerSource({
                customerId: currentdetails?.id,
                data: {
                    esim: false,
                    simType: 'PHYSICAL',
                    activationJourneyStatus: 'IN_PROGRESS',
                    physicalSimsOrdered: currentdetails?.physicalSimsOrdered
                        ? currentdetails?.physicalSimsOrdered + 1
                        : 1,
                },
            });
        }
    };
    imeiHandler = (e: any) => {
        // let usedImei: any = localStorage.getItem('usedImeiNos');
        // usedImei = JSON.parse(usedImei);
        this.setState({ imeiNumber: e.target.value, imeiErr: '' });
        if(e.target.value.length === 15) {
            let currentdetails: any = localStorage.getItem('customerDetail');
            currentdetails = JSON.parse(currentdetails);
            let secondaryCustomer: any = localStorage.getItem('secondaryCustomerDetail');
            secondaryCustomer = JSON.parse(secondaryCustomer);
            let occurence: any;
            if(secondaryCustomer) {
                occurence = secondaryCustomer.peerAccountRef.split('|')[2];
            } else {
                occurence = currentdetails.peerAccountRef.split('|')[2];
            }
            TagManager.dataLayer({
                dataLayer: {
                    event: "Imei_type",
                    accountNo: currentdetails?.meta?.customer_statement_number,
                    line_number: occurence,
                    typed_IMEI: e.target.value,
                },
              });
            // this.GAAndFBEventsHandler("Imei_type", currentdetails?.meta?.customer_statement_number, occurence, e.target.value)
        }

        // if (usedImei?.includes(e.target.value)) {
        //     this.setState({ imeiErr: 'This device IMEI is already in use.' });
        // } else {
        //     this.setState({ imeiErr: '' });
        // }
    };
    // GAAndFBEventsHandler =(buttonVal: string, accNumber?: any, lineNumber?:any, size?:any) => {
    //     pushTrackingEventsToGAAndFBNew("event", buttonVal, {
    //       screenName: "home",
    //       buttonValue: buttonVal, 
    //       accNumber: accNumber,
    //       lineNumber: lineNumber,
    //       data: size,
    //     });
    //   };
    checkHandler = async () => {
        if (
            this.state.imeiNumber &&
            this.state.imeiErr === '' &&
            this.state.imeiNumber.length === 15 &&
            /^\d+$/.test(this.state.imeiNumber)
        ) {
            // await this.setState({ checkClick: true });
            this.setState({
                checkClick: true,
            });
            this.props.ActivationActions.imei({
                imei: this.state.imeiNumber,
                countryCode: 'usa',
                other1:
                    this.props.CheckoutState &&
                    this.props.CheckoutState.getCustomer &&
                    this.props.CheckoutState.getCustomer.data &&
                    this.props.CheckoutState.getCustomer.data.source
                        ? this.props.CheckoutState.getCustomer.data.source
                        : '',
            });
        } else {
            if (this.state.imeiNumber === '') {
                this.setState({
                    imeiErr: 'Enter Your Device IMEI or MEID Number',
                });
            } else if (this.state.imeiNumber !== '' && this.state.imeiNumber.length !== 15) {
                this.setState({
                    imeiErr: 'Enter valid IMEI Number',
                });
            } else if (this.state.imeiNumber !== '' && !/^\d+$/.test(this.state.imeiNumber)) {
                this.setState({
                    imeiErr: 'Please enter only digits',
                });
            }
        }
    };
    nextHandler = () => {
        this.props.changeCurrentPage('Step2');
    };
    editHandler = () => {
        this.setState({
            isData: false,
        });
    };
    onHide = () => {
        this.setState({ isCompatible: false, checkClick: false });
    };
    onHide5G = () => {
        this.setState({ is5Gmodal: false, checkClick: false });
    };

    backHandler = () => {
        this.props.changeCurrentPage('MainPage');
    };
    notifyMe = () => {
        let user1: any = localStorage.getItem('currentuser');
        user1 = JSON.parse(user1);
        let email: string = user1 && user1.email ? user1.email : '';
        let secondaryCustomer: any = localStorage.getItem('secondaryCustomerDetail');
        secondaryCustomer = JSON.parse(secondaryCustomer);
        let payload = {
            email: email,
            website_imei_incompatibility_reason: '5GDevice',
            is_test: globalVal.hubspot_is_test,
            is_qa: globalVal.hubspot_is_qa,
        };
        email &&
            this.props.homeAction.getInTouch({
                data: {
                    emailId: email,
                    hubspotMap: payload,
                },
            });
        this.setState({
            is5Gmodal: false,
        });
        window.scroll(0, 0);
        store.addNotification({
            // title: 'Success',
            message: activationPage.notification5G,
            type: 'info',
            insert: 'top',
            container: 'top-full',
            animationIn: ['animate__animated', 'animate__fadeIn'],
            animationOut: ['animate__animated', 'animate__fadeOut'],
            dismiss: {
                duration: 2000,
                showIcon: true,
            },
            id: 'activationNotifyMe',
        });
    };
    tryAnotherImei = () => {
        this.onHide5G();
    };
    taxCalculationType1 = (amount?: number) => {
        const { shipPlan } = this.state.formData;
        let user1: any = localStorage.getItem('currentuser');
        user1 = JSON.parse(user1);
        let shipPlanCost: number =
            shipPlan && shipPlan.split('$') && shipPlan.split('$')[1] ? parseFloat(shipPlan.split('$')[1]) : 0;

        this.props.CheckoutActions.TaxCalculationByAddressType1({
            countryCode: 'USA',
            data: {
                address: {
                    name: this.state.shippingAddress.name,
                    address1: this.state.shippingAddress.address1,
                    city: this.state.shippingAddress.city,
                    country: 'USA',
                    state: this.state.shippingAddress.state,
                    type: 'type1',
                    zip: this.state.shippingAddress.zip,
                },
                amount: amount ? amount : shipPlanCost,
                type: 1,
                reachPlanId: user1.reachPlanId,
            },
        });
    };
    confirmHandler = () => {
        if (this.state.simClicked) {
            this.setState({
                // checkClick: true,
                showBuySimModal: true,
                showSimPreferenceModal: false,
                simClicked: false,
            });
            isPaymentEnabled && this.taxCalculationType1();
        } else {
            this.props.changeCurrentPage('Step2');
        }
    };
    fetchData = async () => {
        const shippingRate: any = await firebase.database().ref('/shippingRates');
        shippingRate.on('value', (snapshot: any) => {
            const data = snapshot.val();
            let sendSimOptions: any = [];
            let formData = this.state.formData;
            data.length > 0 &&
                data.map((el: any) => {
                    return sendSimOptions.push({
                        label: `${el && el.name} - $${el && el.shippingAmount}`,
                        value: el && el.serviceType,
                        cost: el && el.shippingAmount,
                        ...el,
                    });
                });
            formData['shipPlan'] = sendSimOptions.length > 0 && sendSimOptions[0] && sendSimOptions[0].label;
            this.setState({ sendSimOptions: sendSimOptions });
        });
    };

    findCodeByState = (state: string) => {
        let code = usaState.find((el: any) => el.label.toLowerCase() === state.toLowerCase());
        return code && code.value;
    };

    findLabelByState = (state: string) => {
        let code = usaState.find((el: any) => el.label.toLowerCase() === state.toLowerCase());
        return code && code.label;
    };
    updateUserInFirebaseDatabase = async (type: string, value: any) => {
        await firebase
            .database()
            .ref('userWebJourneyData/' + btoa(this.state.email))
            .once('value')
            .then((snapshot: any) => {
                let userData = snapshot.val();
                userData[type] = value;
                if (type === 'selectedPlan') {
                    userData['extraLines'] = value && value.line - 1;
                    userData['reachPlanId'] = value && value.plan && value.plan.name;
                }
                if (type === 'deliveryOption') {
                    let sendOption: any = this.state.sendSimOptions.find((el: any) => (el && el.label) === value);
                    userData['selectedShippingMethod'] = sendOption;
                }
                firebase
                    .database()
                    .ref('userWebJourneyData')
                    .child(btoa(this.state.email))
                    .update(userData);
            })
            .catch((err: any) => {
                console.log(err);
            });
    };
    onChangeHandler = async (e: any, name: string) => {
        const { formData } = this.state;
        name !== 'address1' && name !== 'sameAddress' && name !== 'streetShipping'
            ? this.setState({ formData: _.set({ ...formData }, name, e.target.value) })
            : this.setState({ formData: _.set({ ...formData }, name, e) });

        if (name === 'zip') {
            let zip = e.target.value;
            zip.length >= 5 &&
                /^\d+$/.test(zip) &&
                this.props.CheckoutActions.StateCityByZipcode({ zipcode: zip, countryCode: 'USA' });
        }
        if (name === 'state') {
            const formData = this.state.formData;
            let code: string = this.findCodeByState(e.target.value);
            let label: string = this.findLabelByState(e.target.value);
            name === 'state' ? (formData['stateCode'] = code) : (formData['stateCodeShipping'] = code);
            formData['state'] = label;
            await this.setState({ formData: formData });
            this.addressUpdateFunction(formData);
        }
        if (name === 'shipPlan') {
            let sendOption: any = this.state.sendSimOptions.find((el: any) => (el && el.label) === e.target.value);
            // pushTrackingEventsToGAAndFB({
            //     category: 'Swift Purchase',
            //     actionType: 'Shipping Selection',
            //     label: sendOption.deliveryDays < 3 ? 'Express' : 'Standard',
            // });
            this.setState({
                loader: true,
            });
            if (isPaymentEnabled) {
                this.taxCalculationType1(sendOption?.cost);
                this.updateUserInFirebaseDatabase('deliveryOption', e.target.value);
            }
        }
    };
    addressUpdateFunction = (formData: any) => {
        let address: any = [
            {
                name: `${formData && formData.firstName} ${formData && formData.lastName}`,
                address1: formData && formData.address1,
                address2: formData && formData.apt,
                city: formData && formData.city,
                country: 'USA',
                phone: formData && formData.billingNumber,
                state: formData && formData.stateCode,
                type: 'billing',
                zip: formData && formData.zip,
            },
            {
                address1: formData && formData.sameAddress ? formData.address1 : formData.streetShipping,
                address2: formData && formData.sameAddress ? formData.apt : formData.aptShipping,
                city: formData && formData.sameAddress ? formData.city : formData && formData.cityShipping,
                country: 'USA',
                name: `${formData && formData.firstName} ${formData && formData.lastName}`,
                phone: formData && formData.billingNumber,
                state: formData && formData.sameAddress ? formData.stateCode : formData && formData.stateCodeShipping,
                type: 'shipping',
                zip: formData && formData.sameAddress ? formData.zip : formData && formData.zipCodeShipping,
            },
        ];
        localStorage.setItem('addresses', address);
    };
    validateData = (formData: any) => {
        if (formData.firstName === '' || formData.lastName === '') {
            return false;
        }
        if (
            formData.address1 === '' ||
            formData.city === '' ||
            formData.state === '' ||
            formData.stateCode === '' ||
            formData.zip === '' ||
            formData.city.length < 2
        ) {
            return false;
        }
        if (formData.zip !== '' && formData.zip.length < 5) {
            return false;
        }
        return true;
    };
    updateCustomerHandler = (val: any) => {
        let currentdetails: any = localStorage.getItem('customerDetail');
        currentdetails = JSON.parse(currentdetails);
        let shippingAdd: any =
            this.state.customerDetails &&
            this.state.customerDetails.addresses

        shippingAdd.map((el:any) => {
            if(el.type === "shipping") {
                el.address1 = val?.address1;
                el.city = val?.city;
                el.state = val?.state;
                el.phone = "";
                el.zip = val?.zip;
                el.address2 = val?.apt ? val.apt : '';
            }
        })
        this.setState({ loader: true})
        this.props.CheckoutActions.UpdateCustomerSource({
            customerId: currentdetails?.id,
                data: {
                    addresses: shippingAdd
                },
        });
    };
    saveHandler = () => {
        this.setState({
            formDataValidation: true,
        });
        if (this.validateData(this.state.formData)) {
            this.setState({ shippingAddress: _.set({ ...this.state.formData }) });
            this.updateCustomerHandler(this.state.formData)
        }
    };
    handleSelect = (address: any, type: string) => {
        geocodeByAddress(address)
            .then(async (results: any) => {
                let city: string = '',
                    state: string = '',
                    zip: string = '',
                    country: string = '',
                    route: string = '',
                    streetNumber: string = '';
                let { formData } = this.state;
                results &&
                    results[0] &&
                    results[0].address_components &&
                    results[0].address_components.map((el: any) => {
                        state = el.types.includes('administrative_area_level_1') ? el.long_name : state;
                        zip = el.types.includes('postal_code') ? el.short_name : zip;
                        city = el.types.includes('locality')
                            ? el.long_name
                            : el.types.includes('sublocality')
                            ? el.long_name
                            : el.types.includes('neighborhood')
                            ? el.long_name
                            : city;
                        streetNumber = el.types.includes('street_number') ? el.short_name : streetNumber;
                        route = el.types.includes('route') ? el.long_name : route;
                        country = el.types.includes('country') ? el.short_name : country;
                        return null;
                    });
                let code = this.findCodeByState(state);

                if (type === 'billing' && country === 'US') {
                    formData['address1'] = `${streetNumber} ${route}`;
                    formData['city'] = city;
                    formData['state'] = state;
                    formData['zip'] = zip;
                    formData['stateCode'] = code;
                    await this.setState({ formData: formData });
                }
            })
            .catch(error => console.error('error', error));
    };
    addNewCardHandler = () => {
        let data: any;
        if (
            this.props.PostActivationState &&
            this.props.PostActivationState.type4Tax &&
            this.props.PostActivationState.type4Tax.data
        ) {
            data = this.props.PostActivationState.type4Tax.data;
        } else {
            let local: any = localStorage.getItem('tax');
            local = JSON.parse(local);
            data = local;
        }
        localStorage.setItem('addCardAccount', 'true');
        localStorage.setItem('tax', JSON.stringify(data));
        if (this.formRef.current) {
            this.formRef.current.submit();
        }
    };
    hideChangeShippingAdd = () => {
        this.setState({ changeShipAddress: false, showShippingAdd: true });
    };
    shipmentApi() {
        const { shippingAddress, shippingAmount, deliveryDays, shippingData } = this.state;
        let customerDetail: any = localStorage.getItem('customerDetail');
        customerDetail = JSON.parse(customerDetail);
        let secondaryUser: any = localStorage.getItem('secondaryCustomerDetail');
        secondaryUser = JSON.parse(secondaryUser);
        TagManager.dataLayer({
            dataLayer: {
                event: "Confirm_Order",
            },
          });
        
        let estimatedDeliveryDate: any = new Date();
        estimatedDeliveryDate.setDate(estimatedDeliveryDate.getDate() + deliveryDays);
        estimatedDeliveryDate = estimatedDeliveryDate.getTime();

        const payload: any = {
            taxAmount: 0,
            totalAmount: 0,
            cId: customerDetail.id,
            shipmentType: 'PHYSICAL',
            reachCarrierId: shippingData?.reachCarrierId,
            deliveryDays: deliveryDays,
            serviceCode: shippingData?.serviceCode,
            serviceType: shippingData?.serviceType,
            carrierCode: shippingData?.carrierCode,
            shippingAmount: shippingAmount,
            orderType: 'RE_ORDER',
            estimatedDeliveryDate: estimatedDeliveryDate,
            category: 'SIM',
            secondaryCustomers: secondaryUser?.id ? [secondaryUser?.id] : [],
            shipmentReason: "Customer request",
            shipTo: {
                city: shippingAddress?.city,
                country: customerDetail?.addresses[0]?.country,
                name: customerDetail?.addresses[0]?.name,
                phone: customerDetail?.addresses[0]?.phone,
                postalCode: shippingAddress?.zip,
                residential: 'false',
                state: shippingAddress?.state ? shippingAddress?.state : customerDetail?.addresses[0]?.state,
                street1: shippingAddress?.address1 ? shippingAddress?.address1 : customerDetail?.addresses[0]?.address1,
                street2: shippingAddress?.apt ? shippingAddress?.apt : customerDetail?.addresses[0]?.address2,
            },
            items: [
                {
                    quantity: 1,
                    unitPrice: 0.0,
                },
            ],            
        };
        this.props.CheckoutActions.ShippmentOrder({
            data: payload,
        });
    }

    render() {
        const {
            isData,
            imeiNumber,
            model,
            formDataValidation,
            shippingAddress,
            isCurrentESim,
            // showSimPreferenceModal,
            // simPreference,
            changeShipAddress,
            showShippingAdd,
            orderPlaced,
            shippingAmount,
            billingAddress,
        } = this.state;
        const { address1, apt, city, state, zip } = this.state.formData;

        // let shipPlanCost: number =
        //     shipPlan && shipPlan.split('$') && shipPlan.split('$')[1] ? parseFloat(shipPlan.split('$')[1]) : 0;
        let primaryUser: any = localStorage.getItem('customerDetail');
        primaryUser = JSON.parse(primaryUser);
        let secondaryUser: any = localStorage.getItem('secondaryCustomerDetail');
        secondaryUser = JSON.parse(secondaryUser);
        return (
            <div>
                <>
                    <form
                        ref={this.formRef}
                        method="post"
                        name="addCardForm"
                        id="addCardForm"
                        action={process.env.REACT_APP_ADD_CARD_ADDRESS}
                    >
                        <input type="hidden" name="emailId" value={this.state.email ? this.state.email : ''} />
                        <input type="hidden" name="redirectUrl" value={`${window.location.origin}/activation`} />
                    </form>
                </>
                {!this.state.isInvalidImei && (
                    <div className="backButtonActivation">
                        <img
                            src={BackButton}
                            alt="back"
                            className="arrow_icon"
                            onClick={changeShipAddress ? this.hideChangeShippingAdd : this.backHandler}
                        />
                        {!orderPlaced && (
                            <div className="titleMainActivation">
                                {showShippingAdd
                                    ? 'Shipping Charges'
                                    : changeShipAddress
                                    ? 'Enter Shipping Address'
                                    : activationPage.step1 && activationPage.step1.title}
                            </div>
                        )}
                    </div>
                )}
                {changeShipAddress ? (
                    <div className="subtitleText">We'll deliver your Welcome Kit to this address</div>
                ) : (
                    !showShippingAdd &&
                    !this.state.isInvalidImei &&
                    !orderPlaced && (
                        <div className="ProgressBarActivation">
                            <div className="stepsCount">{`Step 1 of ${isCurrentESim ? '3' : '4'}`}</div>
                            <ProgressBar variant="success" now={isCurrentESim ? 33 : 25} className="progressBar" />
                        </div>
                    )
                )}

                <div className="step1Activation">
                    {isData && !this.state.notSupported && !this.state.isInvalidImei ? (
                        <div className="activationBox">
                            <div className="heading">
                                Congrats! {getUserName()}'s device
                                is compatible with {globalVal.long_name}
                                {isCurrentESim ? ' eSIM' : ''}.
                            </div>
                            <div className="mainContainer">
                                <div className="deviceContainer">
                                    <div className="media1">
                                        <div className="picture1">
                                            <img width={19} src={image1} alt="" />
                                        </div>
                                        <div className="pictureBody1">
                                            <div className="text11">Device</div>
                                            <div className="text12">{model ? model : ''}</div>
                                        </div>
                                    </div>
                                    <div className="media1">
                                        <div className="picture1">
                                            <img width={19} src={image2} alt="" />
                                        </div>
                                        <div className="pictureBody1">
                                            <div className="text11">Device ID (IMEI)</div>
                                            <div className="text12">{imeiNumber ? imeiNumber : ''}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="edit-button" onClick={this.editHandler}>
                                    EDIT DEVICE DETAILS
                                </div>
                            </div>
                            <div className="next-button">
                                <Button primary={true} onClick={this.nextHandler}>
                                    PROCEED
                                </Button>
                            </div>
                        </div>
                    ) : this.state.isInvalidImei ? (
                        <div className="invalidImeiDiv">
                            <img
                                src={BackButton}
                                alt="backArrow"
                                className="backBtn"
                                onClick={() => {
                                    this.setState({
                                        isInvalidImei: false,
                                        isData: false,
                                    });
                                }}
                            />
                            <img src={failedIcon} alt="successIcon" />
                            <div className="invalidImeiTitle">Invalid IMEI Number</div>
                            <div className="invalidImeiMsg">
                                Please enter a valid IMEI number to check device compatibility.
                            </div>
                            <div className="invalidImeiBtn">
                                <Button
                                    primary={true}
                                    onClick={() => {
                                        this.setState({
                                            isInvalidImei: false,
                                            isData: false,
                                        });
                                    }}
                                >
                                    TRY AGAIN
                                </Button>
                            </div>
                        </div>
                    ) : this.state.notSupported ? (
                        <div className="activationBox">
                            <div className="failureHeading">
                                Sorry, {getUserName()}'s device
                                isn’t eSIM compatible.
                            </div>
                            <div className="failureSubheading">
                                You’ll have to order an {globalVal?.long_name} SIM before you can proceed to activate
                                services.
                            </div>
                            <div className="line"></div>
                            <div className="failureNote">
                                <span>Note: </span>We need your shipping address to deliver the Welcome Kit.
                            </div>
                            <Button
                                onClick={() => this.setState({ showShippingAdd: true, notSupported: false })}
                                primary={true}
                            >
                                PROCEED
                            </Button>
                            <div
                                className="checkAnother"
                                onClick={() => this.setState({ notSupported: false, imeiNumber: '' })}
                            >
                                CHECK ANOTHER DEVICE
                            </div>
                        </div>
                    ) : showShippingAdd ? (
                        <div className="shippingAddDivContainer">
                            <div className="planDetailsContainer">
                                <div className="planDetails">
                                    <div className="plan">
                                        <div className="planName">Welcome Kit w/SIM card</div>
                                        <div className="planPrice">${this.state.simCost?.toFixed(2)}</div>
                                    </div>
                                    <div className="shipping">
                                        <div className="shippingName">Standard shipping (3-6 days)</div>
                                        <div className="shippingPrice">
                                            ${shippingAmount && shippingAmount?.toFixed(2)}
                                        </div>
                                    </div>
                                    <div className="line"></div>
                                    <div className="note">
                                        A one-time charge for this purchase will reflect in your upcoming invoice.
                                    </div>
                                    <div
                                        className="terms"
                                        onClick={() => {
                                            window.open(process.env.REACT_APP_ASTOUND_TERMS_AND_CONDITIONS_URL);
                                        }}
                                    >
                                        Terms & Conditions
                                    </div>
                                </div>
                            </div>
                            <div className="shippingAdd">
                                <Checkbox
                                    color="default"
                                    checked={this.state.isShippingConfirm}
                                    onChange={() => {
                                        this.setState({ isShippingConfirm: !this.state.isShippingConfirm });
                                    }}
                                />{' '}
                                I want to ship my Welcome Kit to the address below:
                                <br />
                                {shippingAddress?.address1 ? (
                                    <span>
                                        {shippingAddress?.address1}
                                        {', '}
                                        {shippingAddress?.apt && shippingAddress?.apt + ', '}
                                        {shippingAddress?.city}
                                        {', '}
                                        {shippingAddress?.state + ", "}
                                        {shippingAddress?.zip}
                                    </span>
                                ) : (
                                    <span>
                                        {billingAddress?.address1}
                                        {', '}
                                        {billingAddress?.apt && shippingAddress?.apt + ', '}
                                        {billingAddress?.city}
                                        {', '}
                                        {billingAddress?.state}
                                    </span>
                                )}
                                <div
                                    className={this.state.isShippingConfirm ? 'disableCTA changeTxt' : 'changeTxt'}
                                    onClick={() => {
                                        this.setState({
                                            isShippingConfirm: false,
                                            changeShipAddress: true,
                                            showShippingAdd: false,
                                        });
                                    }}
                                >
                                    Edit address
                                </div>
                            </div>
                            <Button
                                onClick={() => {
                                    this.setState({ loader: true });
                                    !this.state.loader && this.shipmentApi();
                                }}
                                primary={true}
                                disabled={!this.state.isShippingConfirm}
                            >
                                {this.state.loader ? (
                                    <div className="loaderCheck text-center">
                                        <CircularProgress />
                                    </div>
                                ) : (
                                    'CONFIRM'
                                )}
                            </Button>
                        </div>
                    ) : orderPlaced ? (
                        <div className="activationStatus">
                            <img src={tick} />
                            <div className="activationStatusTitle">Order Confirmed!</div>
                            <div className="successSubtitle">
                                Your order for {globalVal?.long_name} was placed successfully.
                            </div>
                            <Button primary={true} onClick={() => this.props.changeCurrentPage('Step4')}>
                                Track Order
                            </Button>
                            <div className="backToHome">Back to home</div>
                        </div>
                    ) : changeShipAddress ? (
                        <div className="shippingAddressBlock">
                            <div className="TextFieldsMain">
                                <div className="ProfileCol">
                                    <div className="textFieldHead">Street</div>
                                    <AutoComplete
                                        value={address1}
                                        onChange={(e: any) => this.onChangeHandler(e, 'address1')}
                                        onSelect={(e: any) => {
                                            this.handleSelect(e, 'billing');
                                        }}
                                    />
                                    <div className="errorMessage">
                                        {formDataValidation && address1 === '' ? 'Address cannot be empty' : ''}
                                    </div>
                                </div>
                                <div className="ProfileCol">
                                    <div className="textFieldHead">Apt, unit or floor (Optional)</div>
                                    <TextField
                                        value={apt}
                                        onBlur={() => this.addressUpdateFunction(this.state.formData)}
                                        onChange={(e: any) => this.onChangeHandler(e, 'apt')}
                                        maxlength={maxLength}
                                    />
                                </div>
                            </div>
                            <div className="TextFieldsMain">
                                <div className="ProfileCol">
                                    <div className="textFieldHead">City</div>
                                    <TextField
                                        value={city}
                                        onBlur={() => this.addressUpdateFunction(this.state.formData)}
                                        onChange={(e: any) => this.onChangeHandler(e, 'city')}
                                        maxlength={maxLength}
                                        disabled
                                    />
                                    <div className="errorMessage">
                                        {formDataValidation && city === '' 
                                        ? 'City cannot be empty' 
                                        : formDataValidation && city.length < 2 
                                        ? 'City is invalid'
                                        : ''}
                                    </div>
                                </div>
                                <div className="ProfileCol">
                                    <div className="textFieldHead">State</div>
                                    <SelectDropDown
                                        key={state}
                                        value={state}
                                        options={usaState}
                                        onChange={(e: any) => {
                                            this.onChangeHandler(e, 'state');
                                        }}
                                        disabled
                                    />
                                    <div className="errorMessage">
                                        {formDataValidation && state === '' ? 'State cannot be empty' : ''}
                                    </div>
                                </div>
                            </div>
                            <div className="TextFieldsMain">
                                <div className="ProfileCol">
                                    <div className="textFieldHead">ZIP Code</div>
                                    <TextField
                                        value={zip}
                                        maxlength={10}
                                        onChange={(e: any) => {
                                            if (/^[0-9]+$/.test(e.target.value) || e.target.value === '') {
                                                this.onChangeHandler(e, 'zip');
                                            }
                                        }}
                                        disabled
                                    />
                                    <div className="errorMessage">
                                        {formDataValidation && zip === ''
                                            ? 'Zip code cannot be empty'
                                            : formDataValidation && zip !== '' && !/^\d+$/.test(zip)
                                            ? 'Please enter only digits'
                                            : formDataValidation && zip !== '' && zip.length < 5
                                            ? 'ZIP code must have 5 to 10 digits.'
                                            : ''}
                                    </div>
                                </div>
                                <div className="ProfileCol">
                                    <div className="textFieldHead">Country</div>
                                    <SelectDropDown
                                        disabled
                                        options={[]}
                                        placeholder="United States"
                                        onChange={() => null}
                                    />
                                </div>
                            </div>
                            <div className="shippingAddressSaveButton">
                                <Button primary={true} onClick={!this.state.loader ? this.saveHandler : ()=>{}}>
                                    {this.state.loader ? (
                                        <div className="loaderCheck text-center">
                                            <CircularProgress />
                                        </div>
                                    ) : (
                                        'CONTINUE'
                                    )}
                                </Button>
                            </div>
                        </div>
                    ) : (
                        <div>
                            <div className="activationBox">
                                <div className="heading">
                                    Let’s make sure {" "}
                                    {getUserName()}
                                    's device will work on the {globalVal && globalVal.long_name} network:
                                </div>
                                <div className="InputField">
                                    <div className="imeiText">Enter Device IMEI number</div>
                                    <TextField
                                        value={this.state.imeiNumber}
                                        type="text"
                                        // label="Enter Your Device IMEI or MEID Number"
                                        onChange={(e: any) => {
                                            if (/^[0-9]+$/.test(e.target.value) || e.target.value === '') {
                                                this.imeiHandler(e);
                                            }
                                        }}
                                        error={
                                            this.state.imeiErr !== '' ||
                                            (this.state.imeiNumber !== '' && !/^\d+$/.test(this.state.imeiNumber)) ||
                                            (this.state.imeiNumber !== '' && this.state.imeiNumber.length !== 15) ||
                                            (this.state.checkClick && this.state.imeiNumber === '')
                                            // this.state.isIMEIused
                                        }
                                        helperText={
                                            this.state.imeiErr
                                                ? this.state.imeiErr
                                                : this.state.imeiNumber !== '' && !/^\d+$/.test(this.state.imeiNumber)
                                                ? 'Please enter only digits'
                                                : this.state.imeiNumber !== '' && this.state.imeiNumber.length !== 15
                                                ? 'Enter valid IMEI Number'
                                                : this.state.checkClick && this.state.imeiNumber === ''
                                                ? 'Enter valid IMEI Number'
                                                : // : this.state.isIMEIused
                                                  //     ? 'This device IMEI is already in use.'
                                                  ''
                                        }
                                        maxlength={15}
                                    />

                                    <div className="limit-div">
                                        {this.state.imeiNumber && this.state.imeiNumber.length
                                            ? this.state.imeiNumber.length
                                            : '0'}
                                        /15
                                    </div>
                                </div>
                                <div className="check-button">
                                    <Button
                                        primary={true}
                                        onClick={!this.state.checkClick ? this.checkHandler : ()=>{}}
                                        disabled={
                                            this.state.imeiErr !== '' ||
                                            (this.state.imeiNumber !== '' && !/^\d+$/.test(this.state.imeiNumber)) ||
                                            (this.state.imeiNumber !== '' && this.state.imeiNumber.length !== 15) ||
                                            this.state.imeiNumber === ''
                                            // this.state.isIMEIused
                                        }
                                    >
                                        {this.state.checkClick ? (
                                            <div className="loaderCheck text-center">
                                                <CircularProgress />
                                            </div>
                                        ) : (
                                            'CHECK'
                                        )}
                                    </Button>
                                </div>

                                <div className="noteText">
                                    <span>Note: </span>Make sure your device is unlocked. Your phone should be paid in
                                    full and not under contract with another provider.
                                </div>
                                <div className="line"></div>
                            </div>
                            <div className="BottomContent">
                                <div className="innerDivs">
                                    <div className="div1">How to find your IMEI number</div>
                                    <div className="div2">
                                        On most phones, dial *<span>#06#</span>
                                    </div>
                                </div>
                                <div className="ImageContent">
                                    <div className="media">
                                        <div className="picture">
                                            <img width={19} src={Apple} alt="" />
                                        </div>
                                        <div className="pictureBody">
                                            <div className="text1">iOS</div>
                                            <div className="text2">Go to Settings - General - About - IMEI</div>
                                        </div>
                                    </div>
                                    <div className="media">
                                        <div className="picture">
                                            <img width={19} src={Android} alt="" />
                                        </div>
                                        <div className="pictureBody">
                                            <div className="text1">Android</div>
                                            <div className="text2">Go to Settings - About Phone - Status - IMEI</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch: any) {
    return {
        PostActivationAction: bindActionCreators(PostActivationAction, dispatch),
        CheckoutActions: bindActionCreators(Action, dispatch),
        ActivationActions: bindActionCreators(ActivationAction, dispatch),
        homeAction: bindActionCreators(HomeAction, dispatch),
    };
}

const mapStateToProps = (state: any) => ({
    PostActivationState: state.postActivation,
    CheckoutState: state.checkout,
    ActivationState: state.activation,
    homeState: state.home,
});

export default connect(mapStateToProps, mapDispatchToProps)(Step1);
